import { dcFactory } from 'dc';

dcFactory.init(document.body, false);
window.dcFactory = dcFactory;
